module.exports = __webpack_public_path__ + "static/portfolio-sawangsup-cf7ce9dd785d9688916b2234705c2af4.jpg";